import { render, staticRenderFns } from "./AcquisitionProfitabilityReport.vue?vue&type=template&id=315e0eb5&scoped=true&"
import script from "./AcquisitionProfitabilityReport.vue?vue&type=script&lang=js&"
export * from "./AcquisitionProfitabilityReport.vue?vue&type=script&lang=js&"
import style0 from "./AcquisitionProfitabilityReport.vue?vue&type=style&index=0&id=315e0eb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315e0eb5",
  null
  
)

export default component.exports